module.exports = __webpack_public_path__ + "media/images/emblems/Forst_Laengenbuehl-coat_of_arms-a41c43302578b78295529c4bf9be7289.svg";